import type { PageHintRetrySettings } from '@/types/bundle'

// PRD 39: the choices for the page-hint retry settings, shared by Global
// Configs > Page Hints and a document type's own override on its General
// tab. Values match the backend schema enums exactly.
type RetryTrigger = NonNullable<PageHintRetrySettings['retry_trigger_default']>
type OnExhausted = NonNullable<PageHintRetrySettings['on_exhausted_default']>

export const RETRY_TRIGGER_LABELS: Record<RetryTrigger, string> = {
  critical_only: 'Critical fields only',
  all_fields: 'Any missing field',
  none: 'Never retry',
}

export const ON_EXHAUSTED_LABELS: Record<OnExhausted, string> = {
  give_up: 'Give up (leave missing)',
  send_whole_document: 'Try once more with the whole document',
}
